/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useState, useEffect } from "react";
import { InlineEdit } from "../components/InlineEdit";
import { Button } from "../components/Button";
import { useParams } from "react-router-dom";
import getCroppedImg from "../utils/cropImage";
import useSaveTemplate from "../utils/customHooks";
import ImageUploader from "../utils/ImageUploader";
import { CropperWrapper } from "../utils/CropperWrapper";
import { SpinnerOverlay } from "../utils/SpinnerOverlay";

const Wz126: React.FC = () => {
  const { pdfNameFromUrl } = useParams<{ pdfNameFromUrl: string }>();
  const [text1, setText1] = useState<string>("JANEK");
  const [text2, setText2] = useState<string>("00:26");
  const [text3, setText3] = useState<string>("55");
  const [text4, setText4] = useState<string>("3600");
  const [text5, setText5] = useState<string>("czwartek");
  const [text6, setText6] = useState<string>("7");
  const [text7, setText7] = useState<string>("stycznia");
  const [text8, setText8] = useState<string>("2021");
  const text1BasicSize = 76;
  const text2BasicSize = 35;
  const text3BasicSize = 38;
  const text4BasicSize = 35;
  const text5BasicSize = 14;
  const text6BasicSize = 52;
  const text7BasicSize = 13;
  const text8BasicSize = 13;
  const [fontSizeText1, setFontSizeText1] = useState<number>(text1BasicSize);
  const [fontSizeText2, setFontSizeText2] = useState<number>(text2BasicSize);
  const [fontSizeText3, setFontSizeText3] = useState<number>(text3BasicSize);
  const [fontSizeText4, setFontSizeText4] = useState<number>(text4BasicSize);
  const [fontSizeText5, setFontSizeText5] = useState<number>(text5BasicSize);
  const [fontSizeText6, setFontSizeText6] = useState<number>(text6BasicSize);
  const [fontSizeText7, setFontSizeText7] = useState<number>(text7BasicSize);
  const [fontSizeText8, setFontSizeText8] = useState<number>(text8BasicSize);
  const [image, setImage] = useState<string | null>(null);
  const [croppedImage, setCroppedImage] = useState<string | null>(null);
  const [crop, setCrop] = useState<{ x: number; y: number }>({ x: 0, y: 0 });
  const [zoom, setZoom] = useState<number>(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null);
  const [step, setStep] = useState<"select" | "crop" | "view">("select");
  const { saveTemplate, isSaving } = useSaveTemplate();

  const pdfWidth = "250mm"; // PDF width in mm
  const pdfHeight = "300mm"; // PDF height in mm
  const maxWidth = 300; // Max width for resizing text

  const adjustFontSize = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number,
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px Arial`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px Arial`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px Arial`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

  useEffect(
    () => setFontSizeText1(adjustFontSize(text1, fontSizeText1, text1BasicSize, 12)),
    [text1],
  );
  useEffect(
    () => setFontSizeText2(adjustFontSize(text2, fontSizeText2, text2BasicSize, 18)),
    [text2],
  );
  useEffect(
    () => setFontSizeText3(adjustFontSize(text3, fontSizeText3, text3BasicSize, 12)),
    [text3],
  );
  useEffect(
    () => setFontSizeText4(adjustFontSize(text4, fontSizeText4, text4BasicSize, 12)),
    [text4],
  );
  useEffect(
    () => setFontSizeText5(adjustFontSize(text5, fontSizeText5, text5BasicSize, 12)),
    [text5],
  );
  useEffect(
    () => setFontSizeText6(adjustFontSize(text6, fontSizeText6, text6BasicSize, 12)),
    [text6],
  );
  useEffect(
    () => setFontSizeText7(adjustFontSize(text7, fontSizeText7, text7BasicSize, 12)),
    [text7],
  );
  useEffect(
    () => setFontSizeText8(adjustFontSize(text8, fontSizeText8, text8BasicSize, 12)),
    [text8],
  );

  const handleCropComplete = useCallback((croppedArea: any, croppedAreaPixels: any) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleShowCroppedImage = useCallback(async () => {
    if (image && croppedAreaPixels) {
      // Function to crop the image and get the result
      const croppedImg = await getCroppedImg(image, croppedAreaPixels); // Replace with your image cropping logic
      setCroppedImage(croppedImg);
      setStep("view");
    }
  }, [image, croppedAreaPixels]);

  const handleSave = () => {
    saveTemplate(
      "printable-content",
      {
        pdfWidth: pdfWidth,
        pdfHeight: pdfHeight,
        pdfNameFromUrl: pdfNameFromUrl,
      },
      croppedImage,
      true
    );
  };

  return (
    <div style={{
      width: "100%",
      height: "100%",
      backgroundColor: "#ffffff", padding: "80px",
      position: "relative",
    }}>
      {/* Spinner Overlay */}
      <SpinnerOverlay isVisible={isSaving} />
      <div style={{ position: "absolute", top: "10px", left: "0px", right: "0px", margin: "auto", color: "white", width: "480px", maxWidth: "100%", height: "70px", gap: "30px", display: "flex", alignItems: "center" }}>
        <ImageUploader
                onImageChange={(image) => setImage(image)}
                setStep={setStep}
              />
              {step === "crop" && (
                <p>
                  Aby wykadrować zdjęcie możesz kręcić kółkiem myszy i przesuwać obraz
                </p>
              )}
              <div style={{ }}>
                {step !== "crop" && (
                  <Button onClick={handleSave} disabled={isSaving}>
                    {isSaving ? "Zapisywanie..." : "Zapisz"}
                  </Button>
                )}
                {step === "crop" && (
                  <Button onClick={handleShowCroppedImage}>Zakończ kadrowanie</Button>
                )}
              </div>
      </div>

      <div
        id="printable-content"
        style={{
          position: "relative",
          width: "190mm",
          height: "253mm",
          fontFamily: "JustSayin, MaritimeTropicalNeue",
          backgroundColor: "#ffffff",
          margin: "auto"
        }}
      >
        <InlineEdit
          value={text1}
          setValue={setText1}
          style={{
            fontSize: `${fontSizeText1}px`,
            lineHeight: `${fontSizeText1}px`,
            fontFamily: "MaritimeTropicalNeue",
            zIndex: "12",
            color: "#2b2a29",
            position: "absolute",
            top: "58%",
            left: 0,
            right: 0,
            margin: "auto",
            textAlign: "center",
            letterSpacing: "0.2rem"
          }}
        />
        <InlineEdit
          value={text2}
          setValue={setText2}
          style={{
            fontSize: `${fontSizeText2}px`,
            fontFamily: "JustSayin",
            lineHeight: `${fontSizeText2}px`,
            position: "absolute",
            top: "537px",
            right: "90px",
            maxWidth: "100px",
            textAlign: "center",
            transform: "rotate(13deg)",
            fontWeight: "400",
            color: "#53646b",
            zIndex: "12",
          }}
        />
        <InlineEdit
          value={text3}
          setValue={setText3}
          style={{
            fontSize: `${fontSizeText3}px`,
            fontFamily: "JustSayin",
            lineHeight: `${fontSizeText3}px`,
            position: "absolute",
            top: "722px",
            left: "280px",
            maxWidth: "120px",
            textAlign: "left",
            transform: "rotate(0deg)",
            fontWeight: "400",
            color: "#53646b",
            zIndex: "12",
          }}
        />
        <InlineEdit
          value={text4}
          setValue={setText4}
          style={{
            fontSize: `${fontSizeText4}px`,
            fontFamily: "JustSayin",
            lineHeight: `${fontSizeText4}px`,
            position: "absolute",
            top: "730px",
            right: "215px",
            maxWidth: "120px",
            textAlign: "right",
            transform: "rotate(0deg)",
            fontWeight: "400",
            zIndex: "99",
            color: "#53646b",
          }}
        />
        <InlineEdit
          value={text5}
          setValue={setText5}
          style={{
            fontSize: `${fontSizeText5}px`,
            fontFamily: "JustSayin",
            lineHeight: `${fontSizeText5}px`,
            position: "absolute",
            top: "514px",
            left: "90px",
            maxWidth: "100px",
            textAlign: "center",
            transform: "rotate(-10deg)",
            fontWeight: "400",
            zIndex: "99",
            color: "white"
          }}
        />
        <InlineEdit
          value={text6}
          setValue={setText6}
          style={{
            fontSize: `${fontSizeText6}px`,
            fontFamily: "JustSayin",
            lineHeight: `${fontSizeText6}px`,
            position: "absolute",
            top: "531px",
            left: "97px",
            maxWidth: "100px",
            textAlign: "center",
            transform: "rotate(-10deg)",
            fontWeight: "400",
            zIndex: "99",
            color: "white"
          }}
        />
        <InlineEdit
          value={text7}
          setValue={setText7}
          style={{
            fontSize: `${fontSizeText7}px`,
            fontFamily: "JustSayin",
            lineHeight: `${fontSizeText7}px`,
            position: "absolute",
            top: "586px",
            left: "97px",
            maxWidth: "110px",
            textAlign: "center",
            transform: "rotate(-10deg)",
            fontWeight: "400",
            zIndex: "99",
            color: "white"
          }}
        />
        <InlineEdit
          value={text8}
          setValue={setText8}
          style={{
            fontSize: `${fontSizeText7}px`,
            fontFamily: "JustSayin",
            lineHeight: `${fontSizeText7}px`,
            position: "absolute",
            top: "601px",
            left: "101px",
            maxWidth: "110px",
            textAlign: "center",
            transform: "rotate(-10deg)",
            fontWeight: "400",
            zIndex: "99",
            color: "white"
          }}
        />
        {/* Step: Crop */}
      {image && step === "crop" && (
        <CropperWrapper
          image={image}
          crop={crop}
          zoom={zoom}
          aspect={97 / 121}
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={handleCropComplete}
          style={{
            top: "28mm",
            left: "50.5%",
            height: "112.5mm",
            width: "112.5mm",
            transform: "translateX(-50%)",
            borderRadius: "42% 40% 34% 46%",
          }}
        />
      )}

      {/* Step: View */}
      {croppedImage && step === "view" && (
        <img
          src={croppedImage}
          style={{
            position: "absolute",
            top: "37mm",
            left: "50.5%",
            height: "97.5mm",
            width: "97.5mm",
            transform: "translateX(-50%)",
            borderRadius: "42% 40% 34% 46%",
            zIndex: 2,
          }}
        />
      )}

        <img
          src="/images/WZ126overlay.svg"
          style={{
            position: "absolute",
            zIndex: 5,
            top: '0px',
            left: '0px',
            width: '100%',
            height: '100%'
          }}
        />
        <img
          className=""
          src="/images/WZ126.svg"
          style={{ width: "100%", height: "100%", position: 'absolute', top: '0px', left: '0px' }}
        />
      </div>
    </div>
  );
};

export default Wz126;
